<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2021-12-19 17:08:44
 * @LastEditors: 诺
 * @LastEditTime: 2022-10-27 09:24:59
-->
<template>
  <div class="model" style="background-color: #36841b">
    <div class="modelTitle" style="background-color: #58a72a; color: #fff">
      · 奖品展示 ·
    </div>
    <div class="modelBg">
      <div class="list">
        <!-- <div class="item-wrapper first">
          <div class="item">
            <div class="content" style="border-color: #36841b">
              <div class="itemImg">
                <img
                  src="https://assets.rurushishi.com/activies/football/shouhuan.png"
                />
              </div>
            </div>
            <div class="name" style="background-color: #36841b">
              <div>小米手环</div>
            </div>
            <div class="jp-tag">20积分</div>
          </div>
        </div>
        <div class="item-wrapper first">
          <div class="item">
            <div class="content" style="border-color: #36841b">
              <div class="itemImg">
                <img
                  src="https://assets.rurushishi.com/activies/football/shouhuan.png"
                />
              </div>
            </div>
            <div class="name" style="background-color: #36841b">
              <div>小米手环</div>
            </div>
            <div class="jp-tag">20积分</div>
          </div>
        </div> -->
        <!-- <div class="item-wrapper">
          <div class="item">
            <div class="content" style="border-color: #36841b">
              <div class="itemImg">
                <img
                  src="https://assets.rurushishi.com/activies/football/shouhuan.png"
                />
              </div>
            </div>
            <div class="name" style="background-color: #36841b">
              <div>小米手环</div>
            </div>
            <div class="jp-tag">20积分</div>
          </div>
        </div>
        <div class="item-wrapper">
          <div class="item">
            <div class="content" style="border-color: #36841b">
              <div class="itemImg">
                <img
                  src="https://assets.rurushishi.com/activies/football/shouhuan.png"
                />
              </div>
            </div>
            <div class="name" style="background-color: #36841b">
              <div>小米手环</div>
            </div>
            <div class="jp-tag">20积分</div>
          </div>
        </div> -->
        <div class="item-wrapper" v-for="(item, index) in list" :key="index">
          <div class="item">
            <div class="content" style="border-color: #36841b">
              <div class="itemImg">
                <img :src="item.prizeIcon" />
              </div>
            </div>
            <div class="name" style="background-color: #36841b">
              <div
                class="name-cl"
                style="
                  width: 100% !important;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
              >
                {{ item.prizeName }}
              </div>
            </div>
            <div class="jp-tag">{{ item.points }}澳朵金豆</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
  import {prizesData} from "./components/conmon.js"
export default {
  data() {
    return { list: prizesData };
  },
  created() {
    // this.getmygiftList();
  },
  methods: {
    // async getmygiftList() {
    //   const data = await this.$httpdf.get(this.apiHost + "fc/prizes");
    //   if (data.code == 0) {
    //     this.list = data.data;
    //   }
    // },
  },
  computed: {},
  watch: {},
};
</script>
  <style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.model {
  width: 351px;
  margin: 30px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  // box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border: 10px solid #36841b;
  box-sizing: border-box;

  .modelTitle {
    position: absolute;
    // margin-top: -20px;
    color: white;
    padding: 0 20px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    z-index: 1;
  }

  .modelBg {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 7px;

    .list {
      margin: 0 6px;
      padding-top: 60px;
      display: flex;
      // align-items: center;
      flex-wrap: wrap;

      &.list0 {
        padding-top: 16px;
      }

      &:last-child {
        margin-bottom: 10px;
      }

      .first {
        .item {
          .content {
            width: 149.5px;
            .itemImg {
              width: 142px;
              height: 130px;
              img {
                width: 145px;
                height: 120px;
              }
            }
          }

          .name {
            width: 149.5px;
          }
        }
      }
      .item-wrapper {
        position: relative;
        margin: 0 5px 8px;
        .available {
          position: absolute;
          top: -8px;
          right: -8px;
          width: 40px;
          height: 40px;
          border: 1px solid #ffffff;
          box-sizing: border-box;
          border-radius: 50px;
          color: #fff;
          line-height: 40px;
          text-align: center;
          z-index: 4;
          font-size: 12px;
        }
      }
      .item {
        position: relative;
        border-radius: 4px;
        // overflow: hidden;

        &.gray {
          .content {
            .itemImg {
              img {
                filter: grayscale(60%);
                opacity: 0.5;
              }
            }
          }
        }

        .content {
          border-radius: 4px 4px 0 0;
          background-color: #f0f0f0;
          border-style: solid;
          border-width: 1px;
          width: 96px;
          .itemImg {
            width: 93px;
            height: 93px;
            padding: 4px 0;
            text-align: center;
            border-radius: 5px;
            // border-top-right-radius: 4px;
            overflow: hidden;
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% auto;
            background-blend-mode: luminosity;
            &.residue {
              // background: rgba(255, 255, 255, 0.6);
            }
            img {
              border-radius: 4px 4px 0 0;
              width: 85px;
              height: 83px;
              object-fit: contain;
            }
          }
          .text {
            margin-bottom: 4px;
            text-align: center;
            font-size: 9px;
            line-height: 16px;
            span {
              font-size: 16px;
              line-height: 18px;
              font-weight: bold;
            }
          }
        }

        .name {
          border-radius: 0 0 4px 4px;
          width: 96px;
          font-weight: normal;
          font-size: 11px;
          line-height: 20px;
          color: white;
          text-align: center;
          padding: 6px 2px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 2px;
        }
        .jp-tag {
          position: absolute;
          top: 0;
          left: 0;
          font-size: 10px;
          color: #fff;
          // height: 20px;
          // line-height: 20px;
          padding: 4px 8px;
          border-top-left-radius: 4px;
          border-bottom-right-radius: 4px;
          background: #ff6e37;
        }

        .empty {
          position: absolute;
          top: 26px;
          left: 50%;
          transform: translateX(-50%);
          width: 48px;
          height: 48px;
          text-align: center;
          line-height: 48px;
          color: #fff;
          background: rgba(97, 112, 134, 0.6);
          border-radius: 50px;
          font-size: 14px;
        }
      }
      .gray {
        // background-image: url(https://assets.rurushishi.com/activies/activityCenter/turntableLottery/icon2.png), linear-gradient(#A3AFBF, #A3AFBF);
        // background-blend-mode: luminosity;
        // background-position: top center;
        // background-repeat: no-repeat;
        // background-size: 100% auto;
      }
    }
  }
}

.name_animate {
  animation: marquee_animate 10s infinite linear;
}

@keyframes marquee_animate {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>
  